<template src="./template.html"></template>
<style src="./styles.scss" lang="scss" scoped></style>
<style src="./rating.scss" lang="scss" scoped></style>

<script>
  import { mapActions, mapState } from 'vuex'
  import CommentsPagination from './CommentsPagination'
  import SearchFilter from './SearchFilter'

  export default {
    name: 'RatingPage',
    components: {
      CommentsPagination,
      SearchFilter,
    },
    props: {
      ratingId: String,
      fromLocationModule: Boolean,
    },
    metaInfo() {
      return {
        title: this.$t('meta.rating.title', { name: this.rating.title }),
      }
    },
    data() {
      return {
        step: 1,
      }
    },
    computed: {
      ...mapState('ratings', [
        'rating',
        'comments',
        'commentsPagination',
      ]),
    },
    async created() {
      this.getRating(this.ratingId)
      this.getRatingComments({ id: this.ratingId, page: this.step })
    },
    destroyed() {
      this.clearRating()
    },
    methods: {
      ...mapActions('ratings', [
        'getRating',
        'clearRating',
        'filterRating',
        'getRatingComments',
      ]),
      onFilter() {
        this.filterRating(this.ratingId)
      },
      getComments(page) {
        this.getRatingComments({ id: this.ratingId, page }).then(_ => {
          if (this.commentsPagination) {
            this.step = this.commentsPagination.self
          }
        })
      },
    },
  }
</script>
